import { NoteThread } from '@/components/notes/note-thread';
import type { NoteThreadActions, NoteViewer } from '@/lib/notes-queries';
import type { NoteThread as NoteThreadData } from '@mss_creator/shared';
import { targetTypeWord } from './notes-view-logic';

export interface NotesViewCardProps {
  thread: NoteThreadData;
  viewer: NoteViewer;
  companyName: string;
  actions: NoteThreadActions;
  /** « Voir dans la grille »: leaves the view and opens the notes of the spot. */
  onSeeInGrid: () => void;
  /** The clock of the relative dates; tests pin it. */
  now?: Date;
}

/**
 * One discussion of the Notes view in cards (planche 12): the spot on the left
 * with « Voir dans la grille », and the discussion itself - note, replies,
 * « Répondre… », « Résoudre » - set beside it by the shared `NoteThread`.
 */
export function NotesViewCard({
  thread,
  viewer,
  companyName,
  actions,
  onSeeInGrid,
  now,
}: NotesViewCardProps) {
  const { typeWord, label } = targetTypeWord(thread);
  return (
    <article
      aria-label={`Discussion sur ${thread.targetLabel}`}
      className="grid grid-cols-[200px_minmax(0,1fr)] gap-4 rounded-lg border border-gray-200 bg-white px-4 py-3"
    >
      <div className="flex min-w-0 flex-col items-start gap-0">
        <span className="font-semibold text-gray-500 text-micro uppercase tracking-wider">
          {typeWord}
        </span>
        <span className="break-words font-semibold text-bleu-nuit text-small">{label}</span>
        <button
          type="button"
          onClick={onSeeInGrid}
          className="rounded-sm text-bleu-nuit text-caption underline underline-offset-2 hover:text-bleu-nuit-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bleu-nuit"
        >
          Voir dans la grille
        </button>
      </div>
      <NoteThread
        thread={thread}
        viewer={viewer}
        companyName={companyName}
        actions={actions}
        className="border-0 px-0 py-0"
        {...(now ? { now } : {})}
      />
    </article>
  );
}
